export default __webpack_public_path__ + "static/media/imageLink.d8d7f718.svg";